import SvgEditIcon from "../../../assets/icons/SvgEditicons";

  const Productdata = [
    {
      id: 1,
      SubAccountCode: "SubAccountCode",
      Description: "Description",
     
    },
   
    ];
export default Productdata
